/* INNOVIA STUDIO, interazioni della pagina iniziale.
   Porta in JavaScript semplice le stesse interazioni del progetto React originale. */
(function () {
  "use strict";

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function one(sel, root) { return (root || document).querySelector(sel); }

  /* ---------------------------------------------- Instagram e TikTok */
  var platformButtons = all(".platform-switch button[data-platform]");
  var insightData = {
    instagram: { name: "Instagram", views: "327K", visits: "18,2K" },
    tiktok: { name: "TikTok", views: "618K", visits: "27,6K" }
  };
  platformButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-platform");
      platformButtons.forEach(function (b) { b.classList.toggle("active", b === btn); });
      all("[data-screen]").forEach(function (screen) {
        screen.hidden = screen.getAttribute("data-screen") !== key;
      });
      var d = insightData[key];
      if (!d) return;
      var name = one('[data-ip="name"]'), views = one('[data-ip="views"]'), visits = one('[data-ip="visits"]');
      if (name) name.textContent = d.name;
      if (views) views.textContent = d.views;
      if (visits) visits.textContent = d.visits;
    });
  });

  /* ---------------------------------------------- Viste del sistema */
  var viewButtons = all(".system-tabs button[data-view]");
  viewButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-view");
      viewButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      all("[data-panel]").forEach(function (panel) {
        panel.hidden = panel.getAttribute("data-panel") !== key;
      });
    });
  });

  /* ---------------------------------------------- Fasi del metodo */
  var methodSteps = [
    { num: "01", title: "Analizziamo", copy: "Controlliamo il sito, l’offerta, i social e le pubblicità per capire cosa sta facendo perdere visite o richieste." },
    { num: "02", title: "Decidiamo", copy: "Mettiamo in ordine le idee e scegliamo cosa dire, a chi parlare e da dove conviene iniziare." },
    { num: "03", title: "Creiamo", copy: "Realizziamo il sito, i contenuti e le campagne facendo in modo che comunichino tutti la stessa cosa." },
    { num: "04", title: "Miglioriamo", copy: "Guardiamo i risultati, manteniamo ciò che funziona e correggiamo ciò che può rendere di più." }
  ];
  var methodButtons = all(".method-route button[data-step]");
  methodButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var index = parseInt(btn.getAttribute("data-step"), 10);
      var step = methodSteps[index];
      if (!step) return;
      methodButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      all('[data-md="num"]').forEach(function (el) { el.textContent = step.num; });
      var t = one('[data-md="title"]'), c = one('[data-md="copy"]');
      if (t) t.textContent = step.title;
      if (c) c.textContent = step.copy;
      all("[data-work]").forEach(function (w) {
        w.hidden = parseInt(w.getAttribute("data-work"), 10) !== index;
      });
    });
  });

  /* ---------------------------------------------- Domande frequenti */
  all(".faq-list article button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var article = btn.parentElement;
      var isOpen = article.classList.contains("open");
      all(".faq-list article").forEach(function (a) {
        a.classList.remove("open");
        var b = one("button", a);
        if (b) b.setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        article.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  /* ---------------------------------------------- Audio del video UGC */
  var video = document.getElementById("ugcVideo");
  var soundToggle = document.getElementById("soundToggle");
  if (video && soundToggle) {
    soundToggle.addEventListener("click", function () {
      video.muted = !video.muted;
      soundToggle.textContent = video.muted ? "🔈 AUDIO" : "🔊 ATTIVO";
      soundToggle.setAttribute("aria-label", video.muted ? "Attiva l’audio del video" : "Disattiva l’audio del video");
      var p = video.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
    });
  }

  /* ---------------------------------------------- Pulsante fisso da telefono */
  var mobileCta = document.getElementById("mobileCta");
  if (mobileCta && "IntersectionObserver" in window) {
    var targets = [one("#pacchetti"), one("#contatto"), one(".footer")].filter(Boolean);
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      mobileCta.classList.toggle("mobile-cta-hidden", visible.size !== 0);
      mobileCta.setAttribute("aria-hidden", visible.size !== 0 ? "true" : "false");
      mobileCta.setAttribute("tabindex", visible.size !== 0 ? "-1" : "0");
    }, { threshold: 0.08 });
    targets.forEach(function (t) { observer.observe(t); });
  }

  /* ---------------------------------------------- Preselezione del pacchetto nel modulo */
  var select = document.getElementById("pacchettoSelect");
  if (select) {
    all("[data-package]").forEach(function (link) {
      link.addEventListener("click", function () {
        var wanted = link.getAttribute("data-package");
        all("option", select).forEach(function (opt) {
          if (opt.textContent.trim() === wanted) select.value = opt.value || opt.textContent;
        });
      });
    });
  }
})();
